import { isDefined } from '@ls/js-utils';
import CalcType from 'state/Constants/CalcType';
import ScenarioType from 'state/Constants/ScenarioType';
//import ScaleType from 'state/Constants/ScaleType';
import scope from './scope';

export default class ScenarioAnalysisDefinition {
    #scenarioAnalysisId;
    #scenarioAnalysisFactor;
    #calcType;
    #scenarioType;

    constructor(props = {}) {
        const { scenarioAnalysisId, scenarioAnalysisFactor, calcType, scenarioType } = props;
        this.#scenarioAnalysisId = scenarioAnalysisId;
        this.#scenarioAnalysisFactor = scenarioAnalysisFactor;
        this.#calcType = calcType;
        this.#scenarioType = scenarioType;
    }

    get scenarioAnalysisId() {
        return this.#scenarioAnalysisId;
    }

    get scenarioAnalysisFactor() {
        return this.#scenarioAnalysisFactor;
    }

    get calcType() {
        return this.#calcType;
    }

    get scenarioType() {
        return this.#scenarioType;
    }

    get key() {
        return `${scope} - ${this.#scenarioAnalysisId}, ${this.#scenarioAnalysisFactor}, ${this.#calcType}, ${this.#scenarioType}`;
    }

    get complete() {
        return isDefined(this.#scenarioAnalysisId) && isDefined(this.#scenarioAnalysisFactor) && isDefined(this.#calcType) && isDefined(this.#scenarioType);
    }

    get scenarioAnalysisType() {
        return `${this.#scenarioAnalysisId}`;
    }

    static getDefault = () => new ScenarioAnalysisDefinition({
        scenarioAnalysisId: 3,
        scenarioAnalysisFactor: 'TOTAL',
        calcType: CalcType.Account,
        scenarioType: ScenarioType.Contrib,
    });
    copy = () => ({
        scenarioAnalysisId: this.#scenarioAnalysisId,
        scenarioAnalysisFactor: this.#scenarioAnalysisFactor,
        calcType: this.#calcType,
        scenarioType: this.#scenarioType,
    });
    setScenarioAnalysisId = (value) => new ScenarioAnalysisDefinition({
        ...this.copy(),
        scenarioAnalysisId: value,
    });
    setScenarioAnalysisFactor = (value) => new ScenarioAnalysisDefinition({
        ...this.copy(),
        scenarioAnalysisFactor: value,
    });
    setCalcType = (value) => new ScenarioAnalysisDefinition({
        ...this.copy(),
        calcType: value,
    });
    setScenarioType = (value) => new ScenarioAnalysisDefinition({
        ...this.copy(),
        scenarioType: value,
    });
}
